/* VIDA - Coleccion: filtros y orden sin recargar (API de renderizado de secciones) + drawer de filtros en movil */
(function () {
  'use strict';

  function init(scope) {
    (scope || document).querySelectorAll('[data-coll]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '');
      var sectionId = root.getAttribute('data-section-id');
      var form = root.querySelector('[data-coll-form]');
      var openBtn = root.querySelector('[data-filter-open]');
      var drawer = root.querySelector('[data-filters-drawer]');
      var overlay = root.querySelector('[data-filter-overlay]');
      var badge = root.querySelector('[data-filter-badge]');
      var timer, ctrl, lastFocus;

      /* ---- Drawer (solo se ve en movil; en escritorio los filtros son una columna) ---- */
      var mq = window.matchMedia('(max-width: 989px)');
      function syncA11y() {
        if (!drawer) return;
        /* En movil el panel es un dialogo modal (anuncia nombre, atrapa el foco); en escritorio es una barra lateral normal */
        if (mq.matches) {
          drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true'); drawer.setAttribute('aria-label', 'Filtros');
          if (!root.classList.contains('is-filter-open')) drawer.setAttribute('inert', ''); else drawer.removeAttribute('inert');
        } else { drawer.removeAttribute('role'); drawer.removeAttribute('aria-modal'); drawer.removeAttribute('inert'); }
      }
      syncA11y();
      if (mq.addEventListener) mq.addEventListener('change', syncA11y);
      function trapTab(e) {
        if (e.key !== 'Tab' || !root.classList.contains('is-filter-open') || !mq.matches) return;
        var f = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      document.addEventListener('keydown', trapTab);
      function setOpen(open) {
        root.classList.toggle('is-filter-open', open);
        syncA11y();
        if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('v-lock', open && window.matchMedia('(max-width: 989px)').matches);
        if (open) { lastFocus = document.activeElement; var f = drawer && drawer.querySelector('[data-filter-close]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 300); }
        else if (lastFocus && openBtn) openBtn.focus({ preventScroll: true });
      }
      if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-filter-close]') || e.target === overlay) setOpen(false);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-filter-open')) setOpen(false); });

      /* ---- Filtros en vivo ---- */
      function buildUrl() {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
        var qs = params.toString();
        return window.location.pathname + (qs ? '?' + qs : '');
      }

      function openState() {
        var o = {};
        root.querySelectorAll('[data-fgroup]').forEach(function (d) { o[d.getAttribute('data-fgroup')] = d.open; });
        return o;
      }

      function refresh(url, push) {
        var results = root.querySelector('[data-coll-results]');
        var state = openState();
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        results.classList.add('is-loading');
        var sep = url.indexOf('?') > -1 ? '&' : '?';
        fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { signal: ctrl.signal })
          .then(function (r) { if (!r.ok) throw new Error('bad'); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nr = doc.querySelector('[data-coll-results]');
            var nf = doc.querySelector('[data-coll-filters]');
            var nc = doc.querySelector('[data-coll-count]');
            if (!nr) throw new Error('nodata');
            results.innerHTML = nr.innerHTML;
            results.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
            var cur = root.querySelector('[data-coll-filters]');
            if (nf && cur) {
              cur.innerHTML = nf.innerHTML;
              cur.querySelectorAll('[data-fgroup]').forEach(function (d) { var k = d.getAttribute('data-fgroup'); if (k in state) d.open = state[k]; });
            }
            var count = root.querySelector('[data-coll-count]');
            if (nc && count) count.textContent = nc.textContent;
            var meta = results.querySelector('[data-active-n]');
            var total = meta ? meta.getAttribute('data-total') : '';
            var n = meta ? parseInt(meta.getAttribute('data-active-n'), 10) : 0;
            if (badge) { badge.textContent = n; badge.hidden = !n; }
            var apply = root.querySelector('[data-filter-apply]');
            if (apply && total !== '') apply.textContent = (window.vidaT && window.vidaT(total === '1' ? 'collection.apply_one' : 'collection.apply_many', { n: total })) || ('Ver ' + total + (total === '1' ? ' producto' : ' productos'));
            if (push) window.history.pushState({}, '', url);
          })
          .catch(function (e) { if (e.name !== 'AbortError') window.location.href = url; })
          .finally(function () { results.classList.remove('is-loading'); });
      }

      if (form) {
        form.addEventListener('submit', function (e) { e.preventDefault(); refresh(buildUrl(), true); });
        form.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(function () { refresh(buildUrl(), true); }, 220); });
        form.addEventListener('input', function (e) { if (e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(function () { refresh(buildUrl(), true); }, 700); } });
        form.addEventListener('click', function (e) {
          var clear = e.target.closest('[data-filter-clear]');
          if (clear) { e.preventDefault(); refresh(clear.getAttribute('href'), true); }
        });
      }
      /* Orden: select fuera del aside, pero asociado al formulario */
      var sort = root.querySelector('[data-coll-sort]');
      if (sort && !form) sort.addEventListener('change', function () { window.location.href = window.location.pathname + '?sort_by=' + encodeURIComponent(sort.value); });

      /* Chips de filtro activo y "limpiar" dentro de los resultados */
      root.addEventListener('click', function (e) {
        var a = e.target.closest('[data-chip], .v-fchips__clear');
        if (!a || !form) return;
        e.preventDefault(); refresh(a.getAttribute('href'), true);
      });
      window.addEventListener('popstate', function () { if (form) refresh(window.location.pathname + window.location.search, false); });

      /* Insignia inicial */
      var meta0 = root.querySelector('[data-active-n]');
      if (badge && meta0) { var n0 = parseInt(meta0.getAttribute('data-active-n'), 10); badge.textContent = n0; badge.hidden = !n0; }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
